import { User, TenantUser } from "./user";
import { Kiosk } from "./kiosk";
import { TransactionBatch } from "./transaction-batch";

export class TenantManagement {
    users: Array<TenantUser>;
    kiosks: Array<Kiosk>;
    batches: Array<TransactionBatch>;
    timeZones: Array<string>;
}